import { ContractsSummaryCard } from '~/features/market/contracts/components/ContractsSummaryCard';
import { ActiveNegotiationsCard } from './cards/ActiveNegotiationsCard';
import { UpcomingJobsCard } from './cards/UpcomingJobsCard';

export const ProviderDashboard = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 gap-4">
        <UpcomingJobsCard />
        <ActiveNegotiationsCard />
      </div>
      <ContractsSummaryCard />
    </div>
  );
};
